export default status => {
  if (status) {
    return '#C9FFEF';
  } if (!status) {
    return '#e2e2e2';
  }
  return null;
};
